import { render, staticRenderFns } from "./productInformation.vue?vue&type=template&id=2bf38ea3&scoped=true&"
import script from "./productInformation.vue?vue&type=script&lang=js&"
export * from "./productInformation.vue?vue&type=script&lang=js&"
import style0 from "./productInformation.vue?vue&type=style&index=0&id=2bf38ea3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf38ea3",
  null
  
)

export default component.exports